const services = [
  {
    title: "Bridal Makeup",
    image: "/images/soft-glam.webp",
    price: "Starting from ₹8,000",
    description:
      "A personalized bridal makeup experience designed for your wedding day, engagement and special celebrations.",
    features: [
      "HD / Airbrush Makeup",
      "Custom Skin Preparation",
      "Long-lasting Finish",
    ],
  },
  {
    title: "Party Makeup",
    image: "/images/makeup.webp",
    price: "Starting from ₹2,500",
    description:
      "Glamorous and elegant makeup looks for parties, receptions, birthdays and special occasions.",
    features: [
      "Professional Makeup",
      "Custom Color Matching",
      "Hair Styling",
    ],
  },
  {
    title: "Hairstyling",
    image: "/images/banner-sunrise.jpg",
    price: "Starting from ₹1,500",
    description:
      "From soft curls to elegant bridal buns, we create hairstyles that complete your entire look.",
    features: [
      "Bridal Hairstyles",
      "Curls & Waves",
      "Traditional & Modern Styles",
    ],
  },
];

export default function Services() {
  return (
  <section
  id="services"
  className="section w-full max-w-full overflow-hidden py-16 sm:py-20 md:py-28 relative"
>
      {/* Background */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute top-0 left-1/3 w-96 h-96 rounded-full bg-sunrise-500/10 blur-3xl"></div>

        <div className="absolute bottom-0 right-0 w-80 h-80 rounded-full bg-blush-500/10 blur-3xl"></div>
      </div>

      {/* Heading */}
      <div className="max-w-2xl mx-auto text-center">
        <span className="text-sm uppercase tracking-[0.25em] text-sunrise-300">
          Our Services
        </span>

        <h2 className="mt-3 font-display text-4xl md:text-5xl">
          Everything you need to{" "}
          <span className="text-sunrise-300">feel beautiful</span>
        </h2>

        <p className="mt-5 text-white/70 leading-relaxed">
          Luxury beauty services created around you, your style and your
          special occasion.
        </p>
      </div>

      {/* Services */}
      <div className="mt-10 sm:mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6 px-0">
        {services.map((service) => (
          <article
            key={service.title}
            className="glass rounded-[28px] p-3 group hover:-translate-y-2 transition duration-500"
          >
            {/* Image */}
            <div className="overflow-hidden rounded-[22px]">
              <img
                src={service.image}
                alt={service.title}
                className="w-full aspect-[4/3] object-cover transition duration-700 group-hover:scale-105"
                loading="lazy"
              />
            </div>

            {/* Content */}
            <div className="p-4 pt-5">
              <div className="flex items-start justify-between gap-4">
                <h3 className="font-display text-2xl">
                  {service.title}
                </h3>

                <span className="text-xs text-sunrise-300 whitespace-nowrap">
                  {service.price}
                </span>
              </div>

              <p className="mt-3 text-sm text-white/70 leading-relaxed">
                {service.description}
              </p>

              {/* Features */}
              <ul className="mt-5 space-y-2">
                {service.features.map((feature) => (
                  <li
                    key={feature}
                    className="flex items-center gap-2 text-sm text-white/75"
                  >
                    <span className="text-sunrise-300">✦</span>
                    {feature}
                  </li>
                ))}
              </ul>

              {/* CTA */}
              <a
                href="#booking"
                className="mt-6 inline-flex items-center text-sm font-medium text-sunrise-300 hover:text-white transition"
              >
                Explore Service
                <span className="ml-2 transition group-hover:translate-x-1">
                  →
                </span>
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}